import { styled, Breakpoints } from '@vw-marketing/us-components';

export const InputLabelContainer: any = styled.div`
  display: flex;
  width: 100%;
  flex-flow: column;
  @media (min-width: ${Breakpoints.b960}px) {
    width: max-content;
    flex-flow: row;
  }
`;

export const DateWrapper: any = styled.div`
  @media (min-width: ${Breakpoints.b960}px) {
    padding-left: 5px;
  }
`;
